<style lang="less" scoped>
/deep/table{
    border:1px solid #ccc !important;
  }
  /deep/td{
    border:1px solid #ccc !important;
    padding: 5px 10px;
    text-align: center;
  }
.mainer{
  position: relative;
      .load {
        position: absolute;
        top: 30%;
        left: 50%;
        transform: translate(50%, 50%);
    }
  }
.notes-space{
  position:absolute;
  top: 10px;
  width: 100%;
  height: 43px;
  background-color:#f9f4ef;
  // border-bottom: 1px solid #CCC;
  z-index: 900;
}
.notes-tools{
  position:absolute;
  top: 10px;
  width: 100%;
  height: 42px;
  background-color:#f9f4ef;
  padding:0;
  display: flex;
  justify-content:center;
  align-items:center;
  z-index: 1000;
  .con-inner{
    padding: 0 10px;
    font-size:24px;
    height:100%;
    display: flex;
    align-items:center;
    .color-seting{
      width:24px;
      height:24px;
    }
    &:hover{
      background:#fff;
    }
    &.active{
      background-color:#fff;
    }
    &.disabled:hover{
      background-color:#FFF;
    }
  }
  .split-line{
    margin:0 10px;
    border-right: 1px solid #CCC;
    height:80%;
  }
}
.pigai{
  position:absolute;
  top:10px;
  left: -5px;
  z-index:2000;
  .saveBtn{
    height:42px;
    width:120px;
    line-height:42px;
    margin-left: -5px;
    border-radius: 0px;
  }
  .cancelBtn{
    height:42px;
    width:120px;
    line-height:42px;
    margin-left: -5px;
    border-radius: 0px;
  }
}
// .redo{
//   position:absolute;
//   top:5px;
//   right: 10px;
//   z-index:2000;
//   .redoBtn{
//     height:32px;
//     line-height:32px;
//     background: #A3AF90;
//     color:#fff;
//   }
// }
.w-e-text-container{
  margin-top: 50px;
  margin-left: auto;
  margin-right: auto;
}
.ant-modal-mask{
  z-index: 13000!important;
}
.ant-modal-wrap{
  z-index: 13001!important;
}
</style>
<template>
  <div class="mainer" style="overflow: hidden">
    <a-spin class="load" v-show="loading" />
    <!-- <img width='1000px' height='1000px' :src="this.$resBasePath+'/2021/04/10/7053f03728374a4593492faedefec03c.jpg'" alt=""> -->
    <div class="notes-space" v-show="hide" v-if="isRevise==1?false:true"></div>
    <transition
        enter-active-class="animated slideInDown"
        leave-active-class="animated slideOutUp"
    >
    <div v-show="correcting" class="notes-tools" v-if="hide">
      <div class="con-inner">
        <input v-model="strokeColor"
        class="color-seting" type="color" title="颜色"/>
      </div>
      <div class="con-inner">
        <han-icon type="pen" title="笔画粗细"/>
        <a-slider id="test" style="width:60px"
        v-model="strokeWeight" :max="10" :min="1" />
      </div>
      <div :class="['con-inner', groups&&groups.length?'':'disabled']"
        @click="chexiao"
      >
        <han-icon type="chexiao" title="上一步"/>
      </div>
      <div :class="['con-inner', cxgroups&&cxgroups.length?'':'disabled']"
        @click="redo"
      >
        <han-icon type="redo" title="下一步"/>
      </div>
      <div v-for="(shape, index) in shapeTypes"
        :key="index"
        :class="['con-inner',curShapeType===shape.type?'active':'']"
        @click="selectShape(shape.type)"
        >
          <han-icon :type="shape.type" :title="shape.title"/>
      </div>
      <div class="con-inner">
        <han-icon @click="clearAll" type="clearAll" title="清空"/>
      </div>
    </div>
    </transition>
    <div id="text-container" ref="text-container" class="w-e-text-container" v-html="workUrl">
    </div>
    <div class="pigai" v-show="hide" v-if="isRevise==1?false:true">
      <a-button class="saveBtn" v-if="correcting" :loading="saveLoading" type="primary" @click="save">
        保存
      </a-button>
      <a-button class="cancelBtn" :disabled="isRevise==1" type="primary" style="margin-left:5px" @click="correct">
        {{correcting?'取消':'批改'}}
        <img v-show="!correcting" style="float:right;margin-top:12px;" width='16' height='16' src="../../assets/image/accompany/zhankai.png" alt="">
      </a-button>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import zrender from 'zrender'
import html2canvas from 'html2canvas'
import { decryptDes } from '../../utils/crypto.js'
import HanIcon from 'components/Icon.vue'

const radius = (startPos, endPos) => {
  return Math.sqrt(Math.pow((endPos[0] - startPos[0]), 2) + Math.pow((endPos[1] - startPos[1]), 2))
}
const getPageScroll = () => {
  let x, y
  if (window.pageXOffset) {
    // 查看有无pageXOffset属性：IE9以及IE9以上的浏览器
    x = window.pageXOffset
    y = window.pageYOffset
  } else if (document.compatMode === 'BackCompat') {
    // 混杂（怪异）模式下浏览器
    x = document.body.scrollLeft
    y = document.body.scrollTop
  } else {
    // 标准模式下浏览器
    x = document.documentElement.scrollLeft
    y = document.documentElement.scrollTop
  }
  return {
    // 返回水平距离、垂直距离
    x: x,
    y: y
  }
}
const getElement = () => {
  return new Promise((resolve, reject) => {
    let t = 0
    let getEditorTimer = setInterval(() => {
      const textContainer = document.getElementById('text-container')
      t++
      if (textContainer) {
        t = 0
        clearInterval(getEditorTimer)
        getEditorTimer = null
        resolve(textContainer)
      } else if (t > 100) {
        t = 0
        clearInterval(getEditorTimer)
        getEditorTimer = null
        reject(new Error('初始化编辑器失败!'))
      }
    }, 200)
  })
}
export default {
  props:{workUrl: String,isRevise: Number},
  name: 'Correct',
  components: { HanIcon },
  watch:{
    workUrl(){
      this.$forceUpdate()
    },
    isRevise(e){
      // console.log(e)
    }
  },
  data () {
    return {
      userId: '',
      token: '',
      loading: false,
      hide: true,
      uploadImgUrl: '',//保存返回的图片Url
      editor: null,
      richText: '',
      zr: null,
      groups: [],
      cxgroups: [],
      currentGroup: null,
      cxObj: [], // 撤销元素保存到此数组，以便回复
      correcting: false,
      strokeColor: '#ff0000',
      strokeWeight: 2,
      dragFlag: false,
      startPos: [0, 0],
      graphId: null,
      curShapeType: 'curve',
      canvas: null,
      saveLoading: false,
      shapeTypes: [
        {
          type: 'curve',
          title: '曲线',
          height: '30px'
        },
        {
          type: 'straight',
          title: '直线',
          height: '30px'
        },
        {
          type: 'circle',
          title: '圆形',
          height: '30px'
        },
        {
          type: 'rectangle',
          title: '矩形',
          height: '30px'
        },
        {
          type: 'wenzi',
          title: '文字',
          height: '30px'
        }
      ]
    }
  },
  mounted () {
    this.token = localStorage.getItem('access_token')
  },
  methods: {
    correct () {
      this.correcting = !this.correcting
      if (this.correcting) {
        this.initZrender()
      } else {
        this.canvas.style.display = 'none'
        this.loading = false
      }
    },
    save () {
      let base64String = this.canvas.toDataURL()
      let blob= this.dataURLtoFile(base64String)
      let form = new FormData()
      form.append("bizType","9")
      form.append("customDir","hytc_ebook_server/file")
      let fileOfBlob = new File([blob], new Date()+'.jpg') // 重命名了
      form.append("file", fileOfBlob)
      form.append('access_token', this.token || '')
      let _this = this
      axios({
        url: _this.$uploadUrl,
        method: 'post',
        data: form,
        headers: { 'Content-Type': 'multipart/form-data' }
      }).then(res => {
        if (res && res.status === 200) {
          // _this.$message.success('上传成功')
          _this.uploadImgUrl = res.data.url
          _this.$emit('imgUrl',res.data.url)
          _this.correcting = false
          _this.canvas.style.display = 'none'
          _this.loading = false

        }
      })
    },
    dataURLtoFile(dataURI) {
      let binary = atob(dataURI.split(',')[1])
      let array = []
      for(let i = 0; i < binary.length; i++) {
        array.push(binary.charCodeAt(i))
      }
      return new Blob([new Uint8Array(array)])
    },
    initZrender () {
      this.loading = true
      if (this.canvas) {
        this.canvas.style.display = 'block'
        this.loading = false
        document.documentElement.scrollTop = 0
        return
      }
      document.documentElement.scrollTop = 0
      const videos = document.querySelectorAll('video')
      videos.forEach(video => {
        const vc = document.createElement('canvas')
        const vctx = vc.getContext('2d')
        vc.width = video.scrollWidth
        vc.height = video.scrollHeight
        vctx.drawImage(video, 0, 0, vc.width, vc.height)
        video.style.backgroundImage = `url(${vc.toDataURL()})`
      })
      getElement().then((el)=>{
          html2canvas(el, {
            // backgroundColor: '#FFF',
            allowTaint: true,
            useCORS: true
          }).then(canvas => {
            this.loading = false
            this.correcting = true
            const drawCanvas = document.createElement('canvas')
            drawCanvas.style.zIndex = 8
            drawCanvas.style.position = 'absolute'
            drawCanvas.style.top = '50px'
            drawCanvas.style.left = '0px'
            drawCanvas.width = canvas.width
            drawCanvas.height = canvas.height
            this.zr = zrender.init(drawCanvas) // zrender5.0以上用此初始化有问题
            this.currentGroup = new zrender.Group()
            this.zr.add(this.currentGroup)
            this.groups.push(this.currentGroup)
            const img = new zrender.Image({
              style: {
                x: -getPageScroll().x,
                y: -getPageScroll().y,
                width: canvas.width,
                height: canvas.height,
                image: canvas
              }
            })
            this.currentGroup.add(img)
            el.appendChild(drawCanvas)
            //el.appendChild(canvas)
            // const videos = document.querySelectorAll('video')
            // videos.forEach(video => {
            //   video.style.backgroundImage = ''
            // })
            this.canvas = drawCanvas
            this.drawing()
            //this.toImage()
        })
        this.loading = false
      })

    },
    toImage() {
        html2canvas(this.$refs.text-container).then(canvas => {
          let dataURL = canvas.toDataURL("image/png")
          this.imgUrl = dataURL
          if (this.imgUrl !== "") {
            this.dialogTableVisible = true
          }
        })
      },
    init () {
      const parameter = decryptDes(this.$route.params.parameter)
      const params = parameter.split('&')
      this.token = params[0]
      this.userId = params[1]
      this.styleId = params[2]
      this.bookId = params[3]
      this.classId = params[4]
    },
    selectShape (shape) {
      this.curShapeType = shape
    },
    drawing () {
      this.zr.on('mousedown', e => {
        this.dragFlag = true
        this.startPos = [e.event.zrX, e.event.zrY]
        if (this.currentGroup.childCount() === 0) return false
        const ng = new zrender.Group()
        this.zr.add(ng)
        this.groups.push(ng)
        // 只保留20步
        if (this.groups && this.groups.length > 20) this.groups.shift()
        this.currentGroup = ng
      })
      this.zr.on('mousemove', e => {
        if (!this.dragFlag) return
        if (this.curShapeType === 'move') return
        let obj = null
        const endPos = [e.event.zrX, e.event.zrY]
        this.currentGroup.eachChild(el => {
          if (el.id === this.graphId) {
            this.currentGroup.remove(el)
          }
        })
        if (this.curShapeType === 'straight') {
          obj = this.drawStraight(this.startPos, endPos)
        } else if (this.curShapeType === 'rectangle') {
          obj = this.drawRect(this.startPos, endPos)
        } else if (this.curShapeType === 'circle') {
          obj = this.drawCircle(this.startPos, endPos)
        } else if (this.curShapeType === 'curve') {
          obj = this.drawCurve(this.startPos, endPos)
        }
        this.currentGroup.add(obj)
      })
      this.zr.on('mouseup', e => {
        if (this.curShapeType === 'wenzi') {
          this.drawText(this.startPos)
        }
        this.dragFlag = false
        this.graphId = null
      })
    },
    drawCurve (startPos, endPos) {
      const line = new zrender.Line({
        shape: {
          x1: startPos[0],
          y1: startPos[1],
          x2: endPos[0],
          y2: endPos[1]
        },
        style: {
          lineWidth: this.strokeWeight,
          stroke: this.strokeColor
        },
        cursor: 'move',
        draggable: false
      })
      this.startPos = endPos
      return line
    },
    drawStraight (startPos, endPos) {
      const line = new zrender.Line({
        shape: {
          x1: startPos[0],
          y1: startPos[1],
          x2: endPos[0],
          y2: endPos[1]
        },
        style: {
          lineWidth: this.strokeWeight,
          stroke: this.strokeColor
        },
        cursor: 'move',
        draggable: true
      })
      this.graphId = line.id
      return line
    },
    // 绘制矩形
    drawRect (startPos, endPos) {
      const rect = new zrender.Rect({
        shape: {
          x: startPos[0],
          y: startPos[1],
          width: endPos[0] - startPos[0],
          height: endPos[1] - startPos[1]
        },
        style: {
          lineWidth: this.strokeWeight,
          fill: 'transparent',
          stroke: this.strokeColor
        },
        cursor: 'move',
        draggable: true,
        onclick: (e) => {
          if (this.drawType === 'fill') {
            this.fillColor(e.target.id)
          }
        }
      })
      this.graphId = rect.id
      return rect
    },
    // 绘制圆
    drawCircle (startPos, endPos) {
      const circle = new zrender.Circle({
        shape: {
          cx: startPos[0],
          cy: startPos[1],
          r: radius(startPos, endPos)
        },
        style: {
          lineWidth: this.strokeWeight,
          fill: 'transparent',
          stroke: this.strokeColor
        },
        cursor: 'move',
        draggable: true,
        onclick: (e) => {
          if (this.drawType === 'fill') {
            this.fillColor(e.target.id)
          }
        }
      })
      this.graphId = circle.id
      return circle
    },
    drawText (startPos) {
      const el = document.getElementById('text-container')
      let input = document.getElementById('input')
      if (input) el.removeChild(input)
      input = document.createElement('input')
      input.type = 'text'
      input.id = 'input'
      input.placeholder = '输入文字'
      input.style.color = this.strokeColor
      input.style.fontSize = '18px'
      input.style.position = 'absolute'
      input.style.zIndex = 20
      input.style.border = 'none'
      input.style.left = `${startPos[0]}px`
      input.style.top = `${startPos[1]}px`
      el.appendChild(input)
      input.focus()
      input.onblur = (e) => {
        if (e.target.value === '') return
        const txt = new zrender.Text({
          style: {
            x: startPos[0],
            y: startPos[1],
            textFill: this.strokeColor,
            fontSize: 20,
            text: e.target.value
          },
          cursor: 'move',
          draggable: true
        })
        this.currentGroup.add(txt)
        el.removeChild(input)
        this.curShapeType = 'move'
      }
    },
    clearAll () {
      const vm = this
      this.$confirm({
        title: '确认删除',
        okText: '确认',
        cancelText: '取消',
        content: '确认全部删除吗？',
        onOk () {
          vm.groups.map(group => vm.zr.remove(group))
        }
      })
    },
    // 撤销 此操作每次移除group最后一个元素
    chexiao () {
      const g = this.groups.pop(-1)
      this.zr.remove(g)
      this.cxgroups.push(g)
      // 只保留20步
      if (this.cxgroups && this.cxgroups.length > 20) this.cxgroups.shift()
    },
    redo () {
      const g = this.cxgroups.pop(-1)
      this.zr.add(g)
      this.groups.push(g)
      // 只保留20步
      if (this.groups && this.groups.length > 20) this.groups.shift()
    }
  }
}
</script>
